<script lang="ts">
  import Card from '$lib/components/Card.svelte';
  import Badge from '$lib/components/Badge.svelte';

  let {
    title,
    description,
    blurb,
  }: {
    title: string;
    /** Preferred prop name used by App.svelte routes. */
    description?: string;
    /** @deprecated alias for description */
    blurb?: string;
  } = $props();

  const subtitle = $derived(description ?? blurb ?? '');
</script>

<div class="page stack">
  <Card {title} subtitle={subtitle}>
    <div class="body">
      <Badge tone="accent">Scaffold</Badge>
      <p class="secondary">
        Route module is wired. Data tables, filters, and mutations land here without changing the
        app shell.
      </p>
    </div>
  </Card>
</div>

<style>
  .body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-3);
    min-height: 12rem;
    justify-content: center;
  }

  p {
    max-width: 48ch;
    font-size: var(--text-sm);
  }
</style>
